import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
// import settings from './modules/settings'
import user from './modules/user'
// import tagsView from './modules/tagsView'
// import permission from './modules/permission'
// import commom from './modules/commom'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    // settings,
    user,
    // tagsView,
    // permission,
    // commom
  },
  getters
})

export default store
